import React from "react";

import {
  AccountManager,
  DashboardHeader,
  OnboardingPageContainer,
  ProgramSelector,
} from "../../components";
import { SplitPane } from "../../components/SplitPane";
import { PageType } from "../../constants/pageType";
import { useOnProgramSelectionPageLoad } from "../../helpers/programSelectionPageHelpers";
import { useStrings } from "../../localization/localizationHelpers";

export const ProgramSelectionPage = () => {
  const [dashboardIntroTitle, dashboardMiddleText, dashboardHeaderProgramSelectionPageSubtitle] =
    useStrings(
      "dashboardIntroTitle",
      "dashboardMiddleText",
      "dashboardHeaderProgramSelectionPageSubtitle"
    );
  useOnProgramSelectionPageLoad();

  return (
    <OnboardingPageContainer pageType={PageType.ProgramSelection}>
      <SplitPane rightPane={<div></div>}>
        <DashboardHeader
          title={dashboardIntroTitle}
          mainSubtitle={dashboardMiddleText}
          subtitle={dashboardHeaderProgramSelectionPageSubtitle}
        />
        <AccountManager isNdaUnderReviewStepOrAfter={false} />
        <ProgramSelector />
      </SplitPane>
    </OnboardingPageContainer>
  );
};
